<template>
  <b-modal id="bv-modal-hint-editor"
           @hide="onHide"
           @ok="save"
           ref="modal"
           modal-class="hint-modal"
           size="lg"
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>

    <div  class="d-block text-left">
      <b-form-group>
        <slot name="label">
          <div>
            <div class="text-left" v-html="processedText"></div>
            <hr v-if="(defaultAdditionalRestrictions && isHintInputMessage &&  text !== ' ') || (editorMode && defaultAdditionalRestrictions)">
            <div v-if="!editorMode" class="text-left" v-html="text"></div>
          </div>
        </slot>
        <FormattedInput ref="hintEditorInput" v-if="editorMode && text" v-model="text" height="150"></FormattedInput>
      </b-form-group>
    </div>

    <template #modal-footer>
      <div class="w-100 text-center m-0 p-0">
        <FooterNavbar data-test-path="hint-editor-dialog-footer" class="w-100">
          <FooterButton :type="editorMode ? 'Cancel' : 'Close'" @cancel="onHide" @close="onHide"></FooterButton>
          <FooterButton v-if="editorMode"  type="Save" @save="save"></FooterButton>
        </FooterNavbar>
      </div>
    </template>
  </b-modal>
</template>

<script>

import FooterNavbar from "@/components/navbar/FooterNavbar";
import FooterButton from "@/components/navbar/FooterButton";
import FormattedInput from "@/components/inputs/controls/FormattedInput";
import Tranche from "@/server/com/silkplm/model/plm/Tranche";

export default {
  name: "HintEditorDialog",
  components: {FooterButton, FooterNavbar, FormattedInput},
  async beforeMount() {
  },

  mounted() {
    this.updateProcessedText();
  },

  methods: {
    async save(ev) {
      if (this.resolve != null) {
        if(this.formClass && this.fieldName){
          if(this.hintInput){
            this.result = await Rpc.plm.HintConfiguration.updateHint(this.formClass, this.fieldName, this.text);
          }
          else{
            this.result = await Rpc.plm.HintConfiguration.saveHint(this.formClass, this.fieldName, this.text);
          }
        }
        this.resolve(this.result);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },
    async onHide(ev) {
      EventBus.$emit(Events.cancelHidingGridCellEditor, false);

      if (this.resolve != null) {
        this.resolve(null);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },
    reset() {
      this.text = "";
      this.resolve = null;
    },

    async getHintInput(){
      if(this.formClass && this.fieldName){
        this.hintInput = await Rpc.plm.HintConfiguration.getHintInput(this.formClass, this.fieldName);
        if(this.hintInput){
          this.text = this.hintInput.hintMessage;
        }else{
          this.text = " ";
        }
      }
    },

    async processPlaceholders(rawText) {
      if (!rawText) return '';

      const placeholders = rawText.match(/{{\s*([^{}]+)\s*}}/g) || [];
      let processedText = rawText;

      for (const placeholder of placeholders) {
        const key = placeholder.replace(/{{\s*|\s*}}/g, '');
        try {
          const value = await new Function(`return (async () => { return ${key}; })()`).call(this);
          processedText = processedText.replace(placeholder, value);
        } catch (e) {
          console.error("Error processing placeholder:", placeholder, e);
        }
      }

      return processedText;
    },
    async updateProcessedText() {
      this.processedText = await this.processPlaceholders(this.defaultAdditionalRestrictions);
    }
  },

  watch: {
    'isHintInputMessage': function (val) {
      this.isHintInputMessage = val;
    },
    defaultAdditionalRestrictions: 'updateProcessedText',
  },

  data: () => ({
    title: "title",
    editorMode: false,
    formClass: null,
    fieldName: null,
    defaultAdditionalRestrictions: "message",
    isHintInputMessage: false,
    hintInput: null,
    resolve: null,
    text: null,
    maxLength: 1000,
    result: null,
    processedText: ''
  })
}
</script>
